import React, { memo, useEffect, useState } from 'react'
import cx from 'classnames'
import { isEqual, last } from 'libraries/lodash'
// import nullIcon from 'raw-loader!icons/crop-free.svg' // eslint-disable-line
import nullIcon from 'icons/crop-free.svg' // eslint-disable-line

const cache = new Map()
const resolve = new Map()

const checkPropsAreEqual = (prevProps, nextProps) => (
  isEqual(nextProps.name, prevProps.name) && isEqual(nextProps.className, prevProps.className)
)

const Icon = memo(({ name, className, onClick }) => {
  const getSrc = (_name) => (last(cx(_name).match(/icon-([^\s]+)/g)) || '') + '.svg'
  const getIcon = (_name) => cache.has(getSrc(_name)) ? cache.get(getSrc(_name)) : nullIcon
  const [svg, setSvg] = useState(getIcon(name))

  useEffect(() => {
    let mounted = true
    const updateSvg = (_name) => {
      const url = getSrc(_name)
      if (_name && !cache.has(url)) {
        const resolver = resolve.has(url)
          ? resolve.get(url)
          : fetch(url, { method: 'get', credentials: 'same-origin' })
            .then(r => {
              if (r.status >= 400) { throw new Error('No icon') }
              return r.text()
            })
            .catch(() => nullIcon)
            .then(icon => {
              cache.set(url, icon)
              resolve.delete(url)
            })
        if (!resolve.has(url)) {
          resolve.set(url, resolver)
        }
        resolver.then(() => mounted && setSvg(cache.get(url)))
      }
    }
    updateSvg(name)
    return () => { mounted = false }
  }, [name])

  useEffect(() => {
    const svgIcon = getIcon(name)
    setSvg(svgIcon)
  }, [setSvg, name])

  return !name
    ? null
    : (
      <span
        className={cx('svg-base icon-base', className)}
        dangerouslySetInnerHTML={{ __html: svg }}
        onClick={onClick}
      />
      )
}, checkPropsAreEqual)

export default Icon
